export const getAdvancedGumDisease = (t) => ({
    header: t("advancedGumDisease.header"),
    description: t("advancedGumDisease.description", { returnObjects: true }),
    action: {
        header: t("advancedGumDisease.action.header"),
        tips: t("advancedGumDisease.action.tips", { returnObjects: true }),
    },
});
